const BASE_CRM_URL = "https://crmextapi.ibizaccounts.in/accumen/";
// const BASE_CRM_URL = "http://192.168.1.196:3008/accumen/";
// const BASE_CRM_URL = "http://localhost:3008/accumen/";
// const BASE_CRM_URL = "https://8qfcfg7q-3008.inc1.devtunnels.ms/accumen/";
// const BASE_CRM_URL = "https://rs8qkwbd-3008.inc1.devtunnels.ms/accumen/";
const JSON_BASE_API_URL = "https://devapi.perennialcode.in";
// const JSON_BASE_API_URL = "http://192.168.1.10:5000";
export { BASE_CRM_URL, JSON_BASE_API_URL };
